module.exports = __webpack_public_path__ + "img/hr-branch-particle-13.77763ded.png";